export default __webpack_public_path__ + "static/media/push-notif.f88d577b.png";